import { createSelector } from 'reselect'

export const getFiltersSelector = createSelector(
  filter => filter,
  (filters) => filters
);